import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';

@Component({
  selector: 'app-attritiontabs',
  templateUrl: './attritiontabs.component.html',
  styleUrls: ['./attritiontabs.component.scss'],
})
export class AttritiontabsComponent implements OnInit {
  selectedTypeTabIndex: number = 0;
  selectedTypeTabName = 'demographicwise'
  buttonColorName: any;
  showSetupPopup: boolean = false;
  onDownDownlaodArrow: boolean = false;
  onUpDownlaodArrow: boolean = false;
  currentChartClass = 'attritionChart';
  loggedInUserRole: any | null;
  loggedInUserRoles: any;



  selectedMonth: any;
  selectedMonthName: string = "";
  previousMonthsCount: number = 0;
  loggedInCompanyFiscalyear: any;
  fiscalYearStart: any;
  filteredMonths: any[] = [];

  constructor(
    public router: Router,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private dataRefreshService: DataRefreshService
  ) { }
  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.fiscalYearStart = this.loggedInCompanyFiscalyear === "Jan_Dec" ? "01" : "04";

    this.setFilteredMonths();
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      console.log(this.loggedInUserRole)
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.dataRefreshService.refreshNeeded$.subscribe(() => {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd && event.url.includes('/home/hrportal/attrition')) {
          // this.selectedTypeTabName = 'demographicwise';
          this.selectedTypeTabIndex = 0;
        }
      });
    });
  }
  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        // if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        //   || this.loggedInUserRole == 'PHI Admin' || this.isShowMD) {
        this.showSetupPopup = true;
        this.selectedTypeTabName = '';
        //   }
        // } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
      }
    })
    // this.getpmsyearlist();
    // this.getIncrementFyYear();
  }
  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
  }
  // app-attritionsetup
  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/attrition-setup', { operation: operation }]);
  }
  onClickDownloadBtn(): void {

  }
  onMenuClose(): void {

  }
  exportTableToPDF(elementId: string) {
    this.currentChartClass = 'exportToPng';
    const element = document.getElementById(elementId);

    if (!element) {
      console.error('Element not found');
      return;
    }

    const originalWidth = element.scrollWidth;
    const originalHeight = element.scrollHeight;

    const MAX_CANVAS_SIZE = 52767;
    const scale = Math.min(1, MAX_CANVAS_SIZE / Math.max(originalWidth, originalHeight));

    setTimeout(() => {
      html2canvas(element, {
        width: Math.min(originalWidth, MAX_CANVAS_SIZE),
        height: Math.min(originalHeight, MAX_CANVAS_SIZE),
        scale: scale,
        useCORS: true,
        backgroundColor: null,
        logging: false,
        allowTaint: true,
        ignoreElements: (element) => {
          return element.classList.contains('ignore-in-export');
        },
        onclone: (document) => {
          const clonedElement = document.getElementById(elementId);
          if (clonedElement) {
            clonedElement.style.backgroundColor = 'transparent';
            clonedElement.style.background = 'transparent';
          }
        }
      }).then((canvas) => {
        try {
          const imgData = canvas.toDataURL('image/png');

          if (!imgData || imgData.length < 100) {
            throw new Error('Invalid image data');
          }

          const pdf = new jsPDF('p', 'mm', 'a4');
          const pageWidth = pdf.internal.pageSize.width;
          const pageHeight = pdf.internal.pageSize.height;

          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(
            imgData,
            'PNG',
            0,
            0,
            imgWidth,
            imgHeight,
            '',
            'FAST'
          );

          pdf.save('org_chart.pdf');
        } catch (error) {
          console.error('PDF export error:', error);
        }
      }).catch((err) => {
        console.error('Canvas rendering error:', err);
      });
    }, 200);

    setTimeout(() => {
      this.currentChartClass = 'attritionChart';
    }, 1000);
  }
  exportToPng(elementId: string, fileName: string): void {
    console.log('Exporting table to PNG:', elementId, fileName);
    // Implement logic using html2canvas or another library
  }
  onClickLogs() {
    this.router.navigate(['/home/hrportal/attrition-logs']);
  }


  allMonths = [
    { key: "01", name: "January" }, { key: "02", name: "February" },
    { key: "03", name: "March" }, { key: "04", name: "April" },
    { key: "05", name: "May" }, { key: "06", name: "June" },
    { key: "07", name: "July" }, { key: "08", name: "August" },
    { key: "09", name: "September" }, { key: "10", name: "October" },
    { key: "11", name: "November" }, { key: "12", name: "December" }
  ];
  setFilteredMonths() {
    if (this.loggedInCompanyFiscalyear === "Jan_Dec") {
      this.filteredMonths = [...this.allMonths];
    } else if (this.loggedInCompanyFiscalyear === "Apr_Mar") {
      this.filteredMonths = [
        ...this.allMonths.slice(3), // April to December
        ...this.allMonths.slice(0, 3) // January to March
      ];
    }
  }

  getMonths() {
    const currentMonth = new Date().getMonth() + 1;
    this.selectedMonth = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;
    this.selectedMonthName = this.allMonths.find(m => m.key === this.selectedMonth)?.name || "";
    this.calculatePreviousMonthsCount();
  }

  onMonthChange(event: any) {
    this.selectedMonth = event.value;
    this.selectedMonthName = this.allMonths.find(m => m.key === this.selectedMonth)?.name || "";
    this.calculatePreviousMonthsCount();
  }

  calculatePreviousMonthsCount() {
    const selectedMonthIndex = this.allMonths.findIndex(m => m.key === this.selectedMonth);

    if (selectedMonthIndex !== -1) {
      if (this.loggedInCompanyFiscalyear === "Jan_Dec") {
        this.previousMonthsCount = selectedMonthIndex + 1;
      } else if (this.loggedInCompanyFiscalyear === "Apr_Mar") {
        const fiscalStartIndex = this.allMonths.findIndex(m => m.key === "04");
        this.previousMonthsCount = (selectedMonthIndex >= fiscalStartIndex)
          ? selectedMonthIndex - fiscalStartIndex + 1
          : 12 - fiscalStartIndex + selectedMonthIndex + 1;
      }
    }
  }
  get canAccessAttrition(): boolean {
    return ['Super Admin', 'HR Admin', 'HOD'].includes(this.loggedInUserRole);
  } 
}